/*
Version 0.140

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2019.

!Changelog

2020
	17-02-2020
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_workshopfilter = {};

(function(){
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************

	this.onready = function() {
		
		/*
		Filter: Click
		*/
		$(document).on('click','.js-filter-item',function() {
			specific_workshopfilter.setActive(
				$(this)
			);
		});

		/*
		Filter Categories: Toggle
		*/
		$(document).on('click', '.js-filter-toggle', function () {
			
			if (
				$('.filter-sticky').is(':visible')
			) {
				// Hide filter
				$(this).html('Show option');
				$('.filter-sticky').stop().slideUp();
			} else {
				// Show filter
				$(this).html('Close option');
				$('.filter-sticky').stop().slideDown();
			}

		});
	
	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	this.setActive = function (
		_this
	) {

		/*
		Filter: Remove active class from all items
		*/
		$('.js-filter-item').removeClass('active');
		$('.js-item').hide().removeClass('active');

		/*
		Filter: Set active class on clicked item
		*/
		if (
			_this.data('filter') == 'all'
		) {
			
			$('.js-item').show().addClass('active');
			
		} else {

			$('.js-item[data-category="' + _this.data('filter') + '"]').show().addClass('active');
			
		}
		
		_this.addClass('active');

		/*
		Reviews : Hide all reviews
		Reviews : Hide all reviews
		Reviews : Hide all reviews
		Reviews : Hide all reviews
		*/
		$('.js-items-reviews').hide();
		
		if (
			_this.data('filter') == 'reviews'
		) {
			
			// Show all reviews
			$('.js-items-reviews').removeClass('hidden').show();
			$('.js-items-upcoming').hide();
			$('.js-items-previous').hide();
			
		} else {

			/*
			Check if there are upcoming or previous and show or hide the blocks
			Find items in: js-items-upcoming-items and js-items-previous-items that are visible
			If there are visible items, show the block, otherwise hide it
			*/
			if ($('.js-items-upcoming-items .js-item.active').length > 0) {
				$('.js-items-upcoming').show();
			} else {
				$('.js-items-upcoming').hide();
			}
			if ($('.js-items-previous-items .js-item.active').length > 0) {
				$('.js-items-previous').show();
			} else {
				$('.js-items-previous').hide();
			}
	
		}

		/*
		Scroll to first .js-item
		*/
		if ($('.js-item.active').length > 0) {
			$('html, body').animate({
				scrollTop: $('.js-item.active').first().offset().top - 100
			}, 500);
		}

	};
		
}).apply(specific_workshopfilter); 